// @flow
import React from 'react'
import I18n from 'i18n-react'

// core
import { getMessageFromValidationError } from '../../ContainerFunctions'

// components
import { FieldLabel } from '../../../Components/'

// types
import type { FieldValidationError } from '../../Types/ValidationError'

type ErrorsPanelItemProps = {
  error: FieldValidationError,
  id: string,
  label: string,
  labelValue: string,
  prefix: string,
  showLabel?: boolean,
}

const ErrorsPanelItem = (props: ErrorsPanelItemProps) => {

  const getMessageFromValidationErrorCl = (validationError: FieldValidationError, prefix: string) => {
    return getMessageFromValidationError(validationError, prefix)
  }

  const getErrorText = () => {
    const error = getMessageFromValidationErrorCl(props.error, props.prefix)
    if (!error) {
      return ''
    }
    return `${I18n.translate(`validationErrors.${error.msg}`, { ...error.data, value: props.labelValue })}`
  }

  return (
    <div>
      <strong>
        {props.showLabel && <FieldLabel
          id={`error_${props.id}`}
          label={`${props.label}:&nbsp;`}
          labelValue={props.labelValue}
        />}
        {getErrorText()}
      </strong>
      <hr/>
    </div>
  )
}

export default ErrorsPanelItem
